const reducer = (state, action) => {
  if (action.type === 'USER_CHALLENGE') {
    return {
      ...state,
      userChallenge: state.userChallenge,
      user: action.user,
    }
  }
  if (action.type === 'LOGIN_FAILED') {
    return {
      ...state,
      loginError: action.e,
    }
  }
  if (action.type === 'LOGGED_IN') {
    return {
      ...state,
      user: action.user,
      userChallenge: null,
      loginError: null,
    }
  }
  if (action.type === 'LOGGED_OUT') {
    return { ...state, user: null }
  }
  return state
}

export default reducer

export const initialState = {
  user: null,
  userChallenge: null,
  loginError: null,
}



// WEBPACK FOOTER //
// ./src/state/reducers.js